import React, { useCallback } from 'react';
import { borderRadius, palette, spaces } from '../../../../../assets/styles/themes/tokens';
import { BubbleMenu, Editor } from '@tiptap/react';
import { styled } from '@mui/material/styles';
import LinkMenu from '../LinkMenu';

interface LinkMenuWrapperProps {
  editor: Editor;
}

const StyledBubbleMenu = styled(BubbleMenu)(() => ({
  padding: spaces.xxs,
  borderRadius: borderRadius.sm,
  backgroundColor: 'white',
  border: `1px solid ${palette.divider}`,
}));

const LinkMenuWrapper: React.FC<LinkMenuWrapperProps> = (props) => {
  const { editor } = props;

  const shouldShow = useCallback(() => {
    const isActive = editor.isActive('link');
    return isActive;
  }, [editor]);

  return (
    <StyledBubbleMenu
      tippyOptions={{ popperOptions: { placement: 'top-start' }, zIndex: 1000 , maxWidth: 'none' }}
      editor={editor}
      pluginKey='linkMenu'
      shouldShow={shouldShow}
      updateDelay={100}
    > 
      <LinkMenu editor={editor} />
    </StyledBubbleMenu>
  );
};

export default LinkMenuWrapper;
